const jumpMap = {};

import {native} from '@ali/amap-lib';
import {EventBus} from './event-bus';

/**
 * 跳转链接处理，带有点击锁定
 * @param {string} URI - 跳转的链接，默认为 500ms
 * @param {Object} config - 定制化参数
 * @property {boolean} [config.needSchema=false]  - 是否强制schema转换，默认 false 不转换
 * @property {boolean} [config.isReplace=false]  - 是否强制replace页面
 * @property {number} [config.delay=0] - 跳转延迟
 * @property {boolean} [config.hideTitleBar=false] - 是否隐藏 titleBar，需要 needSchema 开启
 * @property {boolean} [config.isDecodeHttp=false] - 是否 decodeURIComponent 是 http 的链接
 */
const jumpHandler = (URI, config =
  {
    needSchema: false,
    delay: 0,
    hideTitleBar: false,
    // todo
    resetDelay: 500,
    isReplace:false,
    isDecodeHttp: false,
  }) => {

  return new Promise(((resolve, reject) => {

    let isJump = jumpMap[URI] === true || Object.keys(jumpMap).some(key => jumpMap[key] === true);
    if (isJump) {
      reject(false);
      return false;
    }

    const {
      needSchema,
      delay,
      hideTitleBar,
      resetDelay,
      isReplace,
      isDecodeHttp,
    } = config;

    jumpMap[URI] = true;

    setTimeout(() => {
      Object.keys(jumpMap).forEach(key => jumpMap[key] = false);
    }, resetDelay);

    EventBus.$emit('jumpHandler.jump');

    const isSchema =  !/^(http|https|\/|\.\/|\.\.\/)\S*/.test(URI);　
    if (isSchema) { // scheme
      setTimeout(() => {
        resolve(URI);
        native.loadSchema(URI);
      }, delay);
      return false;
    }

    if (URI.indexOf('.') === 0) {
      let a = document.createElement('a');
      a.href = URI;
      URI = a.href;
      a = null;
    }

    if (needSchema) { // http 强制转 schema
      setTimeout(() => {
        const url = `amapuri://webview/amaponline?url=${encodeURIComponent(URI)}&hide_title=${hideTitleBar ? 1 : 0}`;
        resolve(url);
        native.loadSchema(url);
      }, delay);
      return false;
    }

    setTimeout(() => {
      const url = isDecodeHttp ? decodeURIComponent(URI) : URI;
      resolve(url);
      if (isReplace) {
        window.location.replace(url);
      } else {
        window.location.href = url;
      }
    }, delay)
  }))
};

export default jumpHandler;
